import { Score } from ".."
import { VehicleScore } from "../../../types"

type Props = {
  value: VehicleScore
  dataTestIds?: {
    SCORE?: string
    CHANGE?: string
  }
}

export const VehicleScoreCell = ({ value, dataTestIds }: Props) => (
  <Score change={value.change} dataTestIds={dataTestIds} score={value.score} />
)

VehicleScoreCell.defaultProps = {
  dataTestIds: undefined,
}
